<script setup lang="ts">
import Logo from '@/assets/download_sekai.png'
import { openStoreLink } from '@/utils/outterUrlUtils'

const props = defineProps<Props>()
const emits = defineEmits(['dismissModal'])

interface Props {
  title?: string
  isModalOpen?: boolean
}

async function downloadSekai() {
  openStoreLink()
}
</script>

<template>
  <div v-if="isModalOpen" class="modal-container z-400">
    <div class="modal-content">
      <img :src="Logo" alt="Sekai" class="modal-image">
      <div class="modal-title">
        {{ props?.title || 'Interacting more?' }}
      </div>
      <div class="modal-desc">
        Tell the story in your own voice by creating your Sekai and Characters!
      </div>
      <div class="modal-button" @click="downloadSekai">
        Download Sekai
      </div>
      <div class="modal-text-button" @click="emits('dismissModal')">
        Later
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.50);
  padding: 0 24px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
}

.modal-content {
  background-color: white;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: var(--Round, 16px);
  color: black;
  gap: 16px;
  user-select: none;
}

.modal-title {
  color: #000;
  text-align: center;
  /* Mobile/20-bold-Title 2 */
  font-family: Manrope;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  /* 140% */
  margin: 0 16px;
  margin-bottom: -8px;
}

.modal-desc {
  color: var(--Dark-Gray-Secondary-Text, var(--Color-Semantic-Label-labelSecondary, #535353));
  text-align: center;
  /* Mobile/16-regular-body */
  font-family: Manrope;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  /* 150% */
  margin: 0 16px;
}

.modal-button {
  display: flex;
  width: 100%;
  height: 56px;
  padding: 16px 32px;
  justify-content: center;
  align-items: center;
  border-radius: var(--16, 16px);
  background: var(--Color-Core-actionB, #000);
  color: var(--Color-Core-actionA, #FFF);
  /* Body 2/Bold */
  font-family: Manrope;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  /* 133.333% */
  cursor: pointer;
  margin-bottom: -8px;
}

.modal-text-button {
  color: var(--Color-Core-actionB, #000);
  /* Mobile/16-semibold */
  font-family: Manrope;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  /* 150% */
  cursor: pointer;
  margin: 16px 0;
}

.modal-image {
  display: block;
  width: calc(100% - 32px);
  margin-top: 16px;
}
</style>
